import { useTranslation } from "react-i18next";

import { TransientJobLogChips } from "./TransientJobLogChips";

type LogContextGroup = {
  isSelected: (value: string) => boolean;
  onToggle: (value: string) => void;
  values: readonly string[];
};

type TransientJobLogContextFilterProps = {
  iterations: LogContextGroup;
  scenarios: LogContextGroup;
};

const formatIterationLabel = (value: string, label: (count: number) => string) => {
  if (!/^\d+$/.test(value)) return value;
  return label(Number(value));
};

export const TransientJobLogContextFilter = ({ iterations, scenarios }: TransientJobLogContextFilterProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex h-[60vh] w-40 shrink-0 flex-col gap-6 overflow-auto">
      {scenarios.values.length > 0 ? (
        <div>
          <p className="font-ds-headline-sm mb-2 text-lds-foreground-heading-initial">
            {t("Execution.transient.jobDetails.scenarios")}
          </p>
          <TransientJobLogChips isOn={scenarios.isSelected} onToggle={scenarios.onToggle} values={scenarios.values} />
        </div>
      ) : null}
      {iterations.values.length > 0 ? (
        <div>
          <p className="font-ds-headline-sm mb-2 text-lds-foreground-heading-initial">
            {t("Execution.transient.jobDetails.iterations")}
          </p>
          <TransientJobLogChips
            formatLabel={(value) =>
              formatIterationLabel(value, (count) => t("Execution.transient.jobDetails.iteration", { count }))
            }
            isOn={iterations.isSelected}
            onToggle={iterations.onToggle}
            values={iterations.values}
          />
        </div>
      ) : null}
    </div>
  );
};
